import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { DEFAULT_SIGNING_MUTATION_PARAMS } from "@/modules/patients/detail/conclude/services/useDocumentSigning"
import {
  Ch_signMeasLabPrescriptionDocumentInput,
  useChSignMeasLaboratoryPrescriptionMutation as useChSignMeasLaboratoryPrescriptionMutationType,
} from "@/modules/patients/detail/meas-laboratory-prescription/ch/services/__generated__/useChSignMeasLaboratoryPrescriptionMutation.graphql"

const mutation = graphql`
  mutation useChSignMeasLaboratoryPrescriptionMutation($input: Ch_signMeasLabPrescriptionDocumentInput!) {
    ch_signMeasLabPrescriptionDocument(input: $input) {
      ch_MeasLaboratoryPrescription {
        id
        createdAt
        createdBy
        signedBy
        signedAt
        updatedAt
        updatedBy
        fileId
        ...chMeasLaboratoryPrescriptionFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useChSignMeasLaboratoryPrescriptionMutationType>, "variables"> & {
  id: Ch_signMeasLabPrescriptionDocumentInput["id"]
}

const useChSignMeasLaboratoryPrescriptionMutation = () => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChSignMeasLaboratoryPrescriptionMutationType>(
    mutation,
    DEFAULT_SIGNING_MUTATION_PARAMS,
  )

  const commitHandler = useCallback(
    async (config: Config) => {
      commit({
        variables: {
          input: {
            id: config.id,
          },
        },
        ...config,
      })
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChSignMeasLaboratoryPrescriptionMutation }
